/* SUNKISSED — Cart drawer upsell behaviour (loaded, deferred, by sections/cart-drawer.liquid)
   - Mobile/tablet: open/close the collapsed upsell bar. State lives on the drawer element,
     because the theme re-renders [data-cart-body] after every cart change.
   - Add buttons: short loading state. Adding itself is handled by the theme's existing
     [data-add-variant] handler in sk-global.js, so cart logic stays in one place. */
(function () {
  'use strict';
  var d = document.querySelector('[data-cart]');
  if (!d) return;

  if (d.getAttribute('data-cu-start-open') === 'true') d.classList.add('sk-cu-open');

  function sync() {
    var b = d.querySelector('[data-cu-toggle]');
    if (b) b.setAttribute('aria-expanded', d.classList.contains('sk-cu-open') ? 'true' : 'false');
  }

  function release(btn) {
    if (!btn || !btn.isConnected) return;
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cu-toggle]');
    if (t) { d.classList.toggle('sk-cu-open'); sync(); return; }

    var a = e.target.closest('.sk-cu-add');
    if (a) {
      a.classList.add('is-loading');
      a.setAttribute('aria-busy', 'true');
      /* On success the drawer re-renders and this button is replaced. If the add fails
         (e.g. stock limit, the theme shows a toast) the button must become usable again. */
      setTimeout(function () { release(a); }, 4000);
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'cart_upsell_add', variant_id: a.getAttribute('data-add-variant') });
      } catch (err) {}
    }
  });

  var body = d.querySelector('[data-cart-body]');
  if (body && 'MutationObserver' in window) {
    new MutationObserver(sync).observe(body, { childList: true });
  }
  sync();
})();
